import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { ORDER_PAGE_NAME } from '../../constants/service/app/orderConstants';
import OrderAllListWrap from '../../views/order/all/list/OrderAllListWrap';

const OrderAllList = () => {
  return (
    <PageTemplate pageName={ORDER_PAGE_NAME.ORDER_ALL_LIST}>
      <OrderAllListWrap pageName={ORDER_PAGE_NAME.ORDER_ALL_LIST} />
    </PageTemplate>
  );
};

export default OrderAllList;
